import { Component, DOCUMENT, Inject, Input, OnInit } from '@angular/core';
import { BreakpointObserver, BreakpointState } from '@angular/cdk/layout';
import { BwsBaseComponent } from '@shared/base/base.component';
import { filter, takeUntil } from 'rxjs';
import { ActivationEnd, Router } from '@angular/router';
import { LocalizeRouterService } from '@gilsdav/ngx-translate-router';


@Component({
    selector: 'bws-sidebar',
    templateUrl: './sidebar.component.html',
    styleUrls: ['./sidebar.component.scss'],
    standalone: false
})
export class SidebarComponent extends BwsBaseComponent implements OnInit {

  @Input() public navLinks: BwsNavLink[] = [];

  public isMobileDrawer: boolean = true;
  public locales = this.localizeRouterService.parser.locales;

  constructor(private breakpointObserver: BreakpointObserver,
              private router: Router,
              public localizeRouterService: LocalizeRouterService,
              @Inject(DOCUMENT) private document: Document) {
    super();
  }

  ngOnInit() {
    this.breakpointObserver
      .observe(['(max-width: 991px)'])
      .pipe(takeUntil(this.destroySubject))
      .subscribe((state: BreakpointState) => {
        this.isMobileDrawer = state.matches;
        if (!this.isMobileDrawer) {
          this.hideSidebar();
        }
      });

    this.router.events
      .pipe(takeUntil(this.destroySubject))
      .pipe(filter(ev => ev instanceof ActivationEnd))
      .subscribe(() => {
        if (this.isMobileDrawer) {
          this.hideSidebar();
        }
      })
  }


  public hideSidebar(): void {
    this.document.getElementById('sidebar')?.classList.remove('drawer-on');
  }

  public changeLanguage(newLanguage: string): void {
    this.localizeRouterService.changeLanguage(newLanguage)
  }

  /** flag + native label per supported language (fallback: plain locale code) */
  public languageMeta: { [locale: string]: { flag: string, label: string } } = {
    en: { flag: '/assets/images/flags/united-states.svg', label: 'English' },
    de: { flag: '/assets/images/flags/germany.svg', label: 'Deutsch' },
    fr: { flag: '/assets/images/flags/france.svg', label: 'Français' },
    es: { flag: '/assets/images/flags/spain.svg', label: 'Español' },
    it: { flag: '/assets/images/flags/italy.svg', label: 'Italiano' },
    pl: { flag: '/assets/images/flags/poland.svg', label: 'Polski' },
  };


}

export interface BwsNavLink {
  title?: string;
  route?: string;
  icon?: string;
  children?: BwsNavLink[];
  isCollapsed?: boolean;
  separator?: boolean;
}
